// extracted by mini-css-extract-plugin
module.exports =  {"container":"a_bCi8tOrXC1jLg13LdP","row":"KIbBOE6obr8sqIKbEjkq","heading":"sdw98dWDhZmBbIhOvwaB"};